import { Injectable } from "@angular/core";
import { AccountStatus, GlobalRole, DisableReason, Salutation, Diocese, Organisation, OrganisationStatus, SecretQuestion }
from "../models";
import { Observable } from "rxjs/Observable";

@Injectable()
export class StaticUserDataService {

    public GetAccountStatusList(): AccountStatus[] {
        let accountStatuses = new Array<AccountStatus>();
        accountStatuses = [
            { code: "Pending", name: "Pending", description: "" },
            { code: "Active", name: "Active", description: "" },
            { code: "InActive", name: "InActive", description: "" }];

        return accountStatuses;
    }

    public GetGlobalRoleList(): GlobalRole[] {
        let globalRoleCodes = new Array<GlobalRole>();
        globalRoleCodes = [
            { code: "NETiDSiteAdmin", name: "NETiD Site Admin" },
            { code: "NETiDAdmin", name: "NETiD Admin" },
            { code: "NETiDDiocesanAdmin", name: "NETiD Diocesan Admin" },
            { code: "NETiDDiocesanUser", name: "NETiD Diocesan User" },
            { code: "NETiDUser", name: "NETiD User" }];

        return globalRoleCodes;
    }

    public GetDisableReasonList(): DisableReason[] {
        let disableReasons = new Array<DisableReason>();
        disableReasons = [
            { code: "ExtendedLeave", name: "Extended Leave", sortOrder: 1 },
            { code: "NoLongerRequired", name: "No longer required", sortOrder: 2 },
            { code: "SecurityBreach", name: "Security Breach", sortOrder: 3 },
            { code: "Other", name: "Other", sortOrder: 4 }];
        return disableReasons;
    }

    public GetSalutationList(): Salutation[] {
        let salutations = new Array<Salutation>();
        salutations = [
            { code: "Mr", name: "Mr" },
            { code: "Mrs", name: "Mrs" },
            { code: "Ms", name: "Ms" },
            { code: "Miss", name: "Miss" },
            { code: "Prof", name: "Prof" },
            { code: "Sr", name: "Sr" },
            { code: "Br", name: "Br" },
            { code: "Fr", name: "Fr" },
            { code: "Rev", name: "Rev" },
            { code: "Bishop", name: "Bishop" },
            { code: "Dr", name: "Dr" }];

        return salutations;
    }

    public GetOrganisationStatusList(): OrganisationStatus[] {
        let organisationStatuses = new Array<OrganisationStatus>();
        organisationStatuses = [
            { code: "Pending", name: "Pending", description: "" },
            { code: "Active", name: "Active", description: "" },
            { code: "InActive", name: "InActive", description: "" }];

        return organisationStatuses;
    }

    public GetSecretQuestionsList(): SecretQuestion[] {
        let secretQuestions = new Array<SecretQuestion>();
        secretQuestions = [
            { id: 1001, name: "What was your favourite place to visit as a child?", sortOrder: 1 },
            { id: 1002, name: "Who is your favourite actor, musician, or artist?", sortOrder: 2 },
            { id: 1003, name: "What street did you grow up on?", sortOrder: 3 },
            { id: 1004, name: "What was the make of your first car?", sortOrder: 4 },
            { id: 1005, name: "What is your father's middle name?", sortOrder: 5 },
            { id: 1006, name: "Who is your favourite cartoon character?", sortOrder: 6 }];

        return secretQuestions;
    }

    public GetTestDioceseList(): Observable<Diocese[]> {
        let dioceseList = [
            { dioceseId: 12, dioceseName: "WAGGA WAGGA", publicId: "FEA207DC-B4A7-4616-B4FE-C9CF2A6CE140" },
            { dioceseId: 5, dioceseName: "SYDNEY", publicId: "19EDB3E5-2472-473B-BFCE-9927E4DB5104" }
        ];

        return Observable.of(dioceseList);
    }

    public GetTestOrganisationsByDioceseId(dioceseId): Observable<Organisation[]> {
        let organisationList = new Array<Organisation>();
        if (dioceseId === "5") {
            let sydOrganisation = new Organisation();
            sydOrganisation.name = "Bethlehem College";
            sydOrganisation.publicId = "D6720A77-0F26-4FC8-AD64-449212C20FED";
            sydOrganisation.dioceseId = 5;

            organisationList.push(sydOrganisation);
        }

        if (dioceseId === "12") {
            let waggaOrganisation = new Organisation();
            waggaOrganisation.name = "Henschke Primary School";
            waggaOrganisation.publicId = "C578F014-AC79-4B6C-B82F-C88AB0B9774D";
            waggaOrganisation.dioceseId = 12;

            organisationList.push(waggaOrganisation);
        }

        return Observable.of(organisationList);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/staticUserData.service.ts